import { NotFoundState } from "@rio-cloud/rio-uikit";

const EmptyBudgets = () => {
  return (
    <div className="w-full flex justify-center items-center p-8">
      <NotFoundState
        headline="Nenhum orçamento encontrado"
        message="Por favor, refine sua pesquisa e tente novamente."
        outerClassName="border-none w-full"
      />
    </div>
  );
};

export default EmptyBudgets;

